import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const OpalSummaryVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const [calls, setCalls] = useState(null);

    useEffect(() => {
        setCalls(chartData)
    }, [chartConfig, chartData])

    const formatNumber = (num) => {
        if (num >= 1e9) {
            return (num / 1e9).toFixed(2) + 'B';
        } else if (num >= 1e6) {
            return (num / 1e6).toFixed(2) + 'M';
        } else if (num >= 1e3) {
            return (num / 1e3).toFixed(2) + 'K';
        } else {
            return num.toString();
        }
    };

    return (
        <div className='chart-content'>
            <div className='d-flex align-items-center justify-content-center h-100'
                style={{
                    fontFamily: 'Lato-Regular'
                }}>
                <Container fluid style={{ fontFamily: 'Lato-Regular' }}>
                    <Row className='mb-2' style={{ fontFamily: 'Lato-semibold', fontSize: '2.5rem' }}>
                        <Col className="text-center" style={{ color: "#1D5D9B" }}>{formatNumber(calls?.[0]?.ActualSales ?? 0)}</Col>
                        <Col className="text-center">{formatNumber(calls?.[0]?.Target ?? 0)}</Col>
                        <Col className="text-center">{formatNumber(calls?.[0]?.LYSales ?? 0)}</Col>
                        <Col className="text-center">
                            {calls?.[0]?.Performance != null
                                ? calls[0].Performance.toLocaleString(undefined, { maximumFractionDigits: 2 }) + '%'
                                : '0%'}
                        </Col>
                        <Col className="text-center">
                            {calls?.[0]?.Growth != null
                                ? calls[0].Growth.toLocaleString(undefined, { maximumFractionDigits: 2 }) + '%'
                                : '0%'}
                        </Col>
                    </Row>
                    <Row style={{ fontSize: '1rem' }}>
                        <Col className="text-center">ACTUAL SALES</Col>
                        <Col className="text-center">TARGET</Col>
                        <Col className="text-center">LAST YEAR SALES</Col>
                        <Col className="text-center">PERFORMANCE</Col>
                        <Col className="text-center">GROWTH</Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default OpalSummaryVisual;
